export const environment = {
	production: false,
	baseUrl: "https://giepboffice.pafar.com.ve/public",
	hostURL: "http://localhost:4200",
	port: 4200
};